<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Editar Documento</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="2">
                                    <v-text-field label="Nivel" dense v-model="nivel"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="8" md="4">
                                    <v-text-field label="Documento" dense v-model="doc"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Código" dense v-model="cod"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Edición" dense v-model="ed">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Revisión" dense v-model="rev">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Fecha Revisión" dense v-model="fecha">
                                    </v-text-field>
                                </v-col>
                                <!-- </v-row>
                        <v-row dense> -->
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Originado en" dense v-model="origen">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field label="Responsable" dense v-model="resp">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Cod. Clasificación" dense v-model="clas"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field label="Tiempo (años) " dense v-model="tiempo"></v-text-field>
                                </v-col>
                                <!-- </v-row>
                        <v-row dense> -->
                                <v-col cols="12" sm="12" md="8">
                                    <v-text-field label="Observaciones" dense v-model="obs"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    props: ["visible", "cod"],
    data: (vm) => ({
        usuario: "",
        valid: false,
        deshabilitar: false,
        lazy: false,
        doc: "",
        nivel: "",
        ed: "",
        rev: "",
        fecha: "",
        clas: "",
        resp: "",
        origen: "",
        tiempo: "",
        obs: "",

    }),

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardocumento();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {

            this.nivel = "";
            this.resp = "";
            this.doc = "";
            this.ed = "";
            this.rev = "";
            this.clas = "";
            this.tiempo = "";
            this.fecha = "";
            this.obs = "";
            this.origen = "";
            this.$router.push({ name: "MainSgi" });
        },

        cargardocumento() {
            let self = this;
            axios
                .get("/Sgi/Cargardocumento?", {
                    params: {
                        cod: self.cod,
                    },
                })
                .then((response) => {
                    self.fecha = response.data.fecha;
                    self.nivel = response.data.nivel;
                    self.doc = response.data.doc;
                    self.ed = response.data.ed;
                    self.rev = response.data.rev;
                    self.clas = response.data.clas;
                    self.origen = response.data.origen;
                    self.resp = response.data.resp;
                    self.tiempo = response.data.tiempo;
                    self.obs = response.data.obs;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Editar Documento",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        nivel: this.nivel,
                        doc: this.doc,
                        cod: this.cod,
                        ed: this.ed,
                        rev: this.rev,
                        origen: this.origen,
                        clas: this.clas,
                        resp: this.resp,
                        fecha: this.fecha,
                        tiempo: this.tiempo,
                        obs: this.obs,

                    };

                    let self = this;
                    axios
                        .post("/SGI/EditarDocumento", datos)
                        .then((response) => {

                            self.showAlert({
                                icon: "success",
                                title: "Documento editado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
